export default __webpack_public_path__ + "static/media/repo.306c5f9f.png";